import { SearchFacets } from 'api/graphQL/types/product.type'

export const filterProductTypeOptions = (
    productTypeOptions: Partial<SearchFacets>[]
) => {
    const uniqueDisplayTexts = new Set<string>()
    const uniqueOptionsMap = new Map<string, string>()

    productTypeOptions?.forEach((item) => {
        const productType = item?.value?.trim() || ''
        const parentFamily = item?.parentProductFamily?.trim() || ''

        if (productType && parentFamily) {
            // Normalize the strings
            const normalizedProductType = productType
                .replace(/\s+/g, ' ')
                .trim()
            const normalizedParentFamily = parentFamily
                .replace(/\s+/g, ' ')
                .trim()

            // Since getOptionText only shows the product type, we need to deduplicate by what's actually displayed
            if (!uniqueDisplayTexts.has(normalizedProductType)) {
                uniqueDisplayTexts.add(normalizedProductType)
                const optionString = `${normalizedProductType} || ${normalizedParentFamily}`
                uniqueOptionsMap.set(normalizedProductType, optionString)
            }
        }
    })

    // Convert to array and sort for consistent ordering
    const uniqueOptions = Array.from(uniqueOptionsMap.values()).sort()

    return uniqueOptions
}
